import script from "./MainHeaders.vue?vue&type=script&setup=true&lang=js"
export * from "./MainHeaders.vue?vue&type=script&setup=true&lang=js"

import "./MainHeaders.vue?vue&type=style&index=0&id=6b8e5d4f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b8e5d4f"]])

export default __exports__